import * as React from "react";
import styles from "./container.module.css";

export const _CalendarContainer = ({
  children,
  ...props
}: React.PropsWithChildren<{
  onClick?: () => void;
  role?: string;
  tabIndex?: number;
}>) => {
  return (
    <div className={styles.container}>
      <div className={styles.card} {...props}>
        {children}
      </div>
    </div>
  );
};

export const _CalendarCardContent = ({
  leftColumn,
  rightColumn,
  leftColumnAlignment = "flex-start",
}: {
  leftColumn: React.ReactNode;
  rightColumn: React.ReactNode;
  leftColumnAlignment?: "flex-start" | "center";
}) => {
  const leftColumnClass =
    leftColumnAlignment === "center"
      ? styles.leftColumnCenter
      : styles.leftColumnStart;

  return (
    <div className={styles.cardContent}>
      <div className={leftColumnClass}>{leftColumn}</div>
      <div className={styles.rightColumn}>{rightColumn}</div>
    </div>
  );
};
